import { fmLogo } from "../../../assets";
import { Image } from "./styles";

export const FutureMoneyLogo = () => {
  return <Image src={fmLogo} alt="FutureMoney Logo" />;
};
